module.exports = "<div class=\"table-wrapper\">\r\n     \r\n  <div ng-transclude=\"header\"\r\n       ng-if=\"$ctrl.isHeader\"\r\n       class=\"md-table-header-container\">\r\n  </div>\r\n\r\n  <div ng-transclude=\"actions\"></div>\r\n\r\n  <div ng-transclude=\"table\"\r\n       class=\"md-table-container\">\r\n  </div>\r\n\r\n  <div ng-transclude=\"footer\"\r\n       id=\"footer\">\r\n  </div>\r\n</div>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/modules/utils/grid/grid.html
// module id = 1862
// module chunks = 0